module.exports = __webpack_public_path__ + "img/registerNow.97a2e06b.gif";